import { getScreenSize, variables } from "./components/variables";
import Choices from "choices.js";
import ClassWatcher from "./components/classWatcher";

(function($) {

    const screenWidth = window.innerWidth;

    /**
     * Add Choices.js to select dropdowns
     */
	function initSelects() {
		const $selects = $('select');
        $selects.each(function(){
        
            // Handle tab selects only on mobile
            if ( $(this).hasClass('bde-tabs__select') && screenWidth > variables.largeTabletBreakpoint ) {
                return;
            }

            // Don't trigger if Formidable Forms is going to handle the styling
            if ( $(this).hasClass('frm_slimselect') ) {
                return;
            }

            const choices = new Choices($(this)[0], {
                allowHTML: true,
                searchEnabled: false,
                shouldSort: false,
                itemSelectText: ""
            });
        });
	}
	setTimeout(initSelects, 200);

	// Re-init selects after page change or submit on forms
	$( document ).on( 'frmPageChanged', initSelects );
	$( document ).on( 'frmFormComplete', initSelects );



    /**
     * Header: Adjust background color on menu open/close
     */
    const $header = $('.siteHeader');
    const $headerDropdowns = $header.find('.breakdance-dropdown');
    if ( screenWidth >= variables.largeTabletBreakpoint ) {
        $headerDropdowns.each(function(){
            const thisDropdown = $(this)[0];
            let classWatcher = new ClassWatcher(thisDropdown, 'breakdance-dropdown--open', onHeaderDropdownOpen, onHeaderDropdownClose);
        });
    }

    function onHeaderDropdownOpen() {
        $header.addClass('siteHeader--open');
    }

    function onHeaderDropdownClose() {
        if ( !$headerDropdowns.hasClass('breakdance-dropdown--open') ) {
            $header.removeClass('siteHeader--open');
        }
    }

    /**
     * Top Popup: Push body down/up when popup shows or hides
     */
    const $topPopup = $('#topPopup');
    let isTopPopupOpen = false;
    if ( $topPopup.length ) {
        let popupClassWatcher = new ClassWatcher($topPopup[0], 'breakdance-popup-animating', onTopPopupOpen, popupEmptyCallback);
        $topPopup.find('.breakdance-popup-close-button').on('click', onTopPopupClose);
    }

    function onTopPopupOpen() {
        if ( isTopPopupOpen ) return;
        const $popupInner = $topPopup.find('.breakdance-popup');
        const popupHeight = $popupInner.css('height');
        setTimeout(function(){
            $('html').animate({
                marginTop: popupHeight
            }, 200, 'linear', function(){
                isTopPopupOpen = true;
            });
            $header.animate({
                marginTop: popupHeight
            }, 200, 'linear');
        }, 400);
        
    }

    function onTopPopupClose() {
        if ( !isTopPopupOpen ) return;
        $('html').animate({
            marginTop: 0
        }, 150, 'linear', function(){
            isTopPopupOpen = true;
        });
        $header.animate({
            marginTop: 0
        }, 150, 'linear');
    }

    function popupEmptyCallback() {
        // Empty callback; we're not handling the popup closing through class watching
    }

	
})( jQuery );


/**
 * Accessibe
 */
 (function(){ var s = document.createElement('script'); var h = document.querySelector('head') || document.body; s.src = 'https://acsbapp.com/apps/app/dist/js/app.js'; s.async = true; s.onload = function(){ acsbJS.init(); }; h.appendChild(s); })();


